import { StyleSheet } from 'react-native';
import { errorRed } from '../../constants/palette';
const styles = StyleSheet.create({
  contentContainerStyle: {
    flex: 1,
  },
  mainContainer: {
    flex: 1,
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    // borderColor: 'red',
    // borderWidth: 5,
  },
  headerContainer: {
    marginBottom: 20,
    width: 250, // FIXME: This is a hack and not a long term solution
  },
  logo: {
    marginBottom: 75,
  },
  text: {
    fontSize: 20,
    marginBottom: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  errorText: {
    marginTop: 10,
    color: errorRed,
  },
});

export default styles;
